import React, { useState } from 'react';
import { Box, Typography } from '@mui/material';
import { KeyboardArrowDown } from '@mui/icons-material';
import { DESIGN_TOKENS } from '../../../styles/constants';
import FilterTabs from '../../shared/FilterTabs/FilterTabs';
import Chart from '../../shared/Chart/Chart';

interface PerformanceChartProps {
  categories: string[];
  orders: number[];
  revenue: number[];
  feedbacks: number[];
  questions: number[];
}

const PerformanceChart: React.FC<PerformanceChartProps> = ({ 
  categories, 
  orders, 
  revenue, 
  feedbacks, 
  questions 
}) => {
  const [activeTab, setActiveTab] = useState('orders');
  const [timeFilter] = useState('Last 30 days');

  const tabs = [
    { label: 'Orders', value: 'orders' },
    { label: 'Revenue', value: 'revenue' },
    { label: 'Feedbacks', value: 'feedbacks' },
    { label: 'Questions', value: 'questions' },
  ];

  // Get data based on active tab
  const getChartData = () => {
    switch (activeTab) {
      case 'revenue':
        return categories.map((category, index) => ({
          name: category,
          value: revenue[index] || 0,
        }));
      case 'feedbacks':
        return categories.map((category, index) => ({
          name: category,
          value: feedbacks[index] || 0,
        }));
      case 'questions':
        return categories.map((category, index) => ({
          name: category,
          value: questions[index] || 0,
        }));
      case 'orders':
      default:
        return categories.map((category, index) => ({
          name: category,
          value: orders[index] || 0,
        }));
    }
  };

  return (
    <Box
      sx={{
        backgroundColor: '#FFFFFF',
        borderRadius: '10px',
        padding: '24px',
        boxShadow: '0px 1px 3px rgba(0, 0, 0, 0.1)',
        display: 'flex',
        flexDirection: 'column',
        gap: '24px',
      }}
    >
      {/* Header with Tabs and Date Selector */}
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          gap: '24px',
          flexWrap: 'wrap',
        }}
      >
        <FilterTabs tabs={tabs} activeTab={activeTab} onTabChange={setActiveTab} />
        
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            padding: '10px 12px 7px 20px',
            height: '39px',
            backgroundColor: '#FFFFFF',
            border: '1px solid #F1F4F4',
            borderRadius: '16px',
            cursor: 'pointer',
            '&:hover': {
              backgroundColor: '#F6F8F8',
            },
          }}
        >
          <Typography
            sx={{
              fontFamily: DESIGN_TOKENS.typography.fontFamily,
              fontSize: '16px',
              fontWeight: 400,
              lineHeight: '22.4px',
              color: '#181818',
            }}
          >
            {timeFilter}
          </Typography>
          <KeyboardArrowDown sx={{ fontSize: 24, color: '#181818' }} />
        </Box>
      </Box>
      
      {/* Chart */}
      <Chart data={getChartData()} />
    </Box>
  );
};

export default PerformanceChart;
